import { useEffect } from 'react';
import clss from "./Mfmsg.module.css"
let map

const wrapperStyle = {
  position: "relative",
  width: "100%",
  height: "100%",
  minHeight: 200,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

const mapContainerStyle = {
  position: "relative",
  overflow: "hidden",
  width: "100%",
  flex: 1,
  minHeight: 180,
};

const MAP_CONTAINER_ID = 'mfmsg-map-container';

function KakaoMap(props) {
  const { lat: propLat, lon: propLon } = props;
  const new_script = (src) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.addEventListener('load', () => resolve());
      script.addEventListener('error', (e) => reject(e));
      document.head.appendChild(script);
    });
  };

  useEffect(() => {
    const lat = propLat != null ? parseFloat(propLat, 10) : parseFloat(sessionStorage.dslat, 10);
    const lon = propLon != null ? parseFloat(propLon, 10) : parseFloat(sessionStorage.dslon, 10);
    if (Number.isNaN(lat) || Number.isNaN(lon)) return;

    const scriptUrl = 'https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=b7967dc1f2c2b6f788a029bc7b701f09&libraries=services,clusterer,drawing';
    const runMap = () => {
      const kakao = window['kakao'];
      if (!kakao || !kakao.maps || typeof kakao.maps.load !== 'function') return;

      kakao.maps.load(() => {
        const kakaoMaps = window.kakao?.maps ?? kakao.maps;
        if (typeof kakaoMaps.LatLng !== 'function') return;

        const mapContainer = document.getElementById(MAP_CONTAINER_ID);
        if (!mapContainer) return;

        const center = new kakaoMaps.LatLng(lat, lon);
        const options = { center, level: 3 };
        map = new kakaoMaps.Map(mapContainer, options);
        map.relayout();
        const mapTypeControl = new kakaoMaps.MapTypeControl();
        map.addControl(mapTypeControl, kakaoMaps.ControlPosition.TOPRIGHT);
        map.setMapTypeId(kakaoMaps.MapTypeId.HYBRID);

        const marker = new kakaoMaps.Marker({ position: center });
        marker.setMap(map);
        setTimeout(() => { try { map.relayout(); } catch (_) {} }, 100);
      });
    };

    if (window.kakao?.maps) {
      runMap();
    } else {
      new_script(scriptUrl).then(runMap).catch((err) => console.warn('Kakao map script load failed:', err));
    }
  }, [propLat, propLon]);

  return (
    <div style={wrapperStyle}>
      <span id="maptitle" className={clss.maptitle}>재난위치</span>
      <div id={MAP_CONTAINER_ID} style={mapContainerStyle} />
    </div>
  );
}

export default KakaoMap;
